import {Component, Input} from '@angular/core';

@Component({
  selector: 'yz-page',
  template: `
    <div class="page__bd" [class.page__bd_spacing]="spacing">
      <ng-content></ng-content>
    </div>
  `,
  host: {
    'class': 'page'
  },
  styleUrls: ['./yz-page.component.less']
})
export class YzPageComponent {
  // 页面外层框架

  // 页面内是否有内边距
  @Input() spacing = true;

}
